<div class="mobile-nav-menu d-flex position-fixed flex-column d-lg-none">
  <!-- NAV BAR -->
  <div
    class="mobile-nav-bar d-flex justify-content-between"
    [ngClass]="{
      'bg-primary': isKid
    }"
  >
    <a class="nav-item fw-bold brand p-1" [routerLink]="['/']" routerLinkActive="router-link-active">
      <label id="homeLink" class="accessibility-only">Go To Home Page</label>
      <img alt="" class="home-logo" src="assets/images/logo.png" draggable="false" />
    </a>

    <!--Notifications-->
    <div class="nav-item">
      <fgb-notification-button></fgb-notification-button>

      <button
        attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
        class="nav-item fw-bold navbar-toggler m-0 px-2"
        [ngClass]="{
          'rounded ms-3': isKid
        }"
        (click)="isCollapsed = !isCollapsed"
      >
        <span class="icon material-icons material-mobile-nav">menu</span>
      </button>
    </div>
  </div>

  <!-- NAV SCREEN -->
  <div
    [ngbCollapse]="isCollapsed"
    class="mobile-nav-menu-dropdown"
    [ngClass]="{
      'bg-primary': isKid
    }"
  >
    <div class="d-flex flex-column mobile-nav-menu-content">
      <div
        class="mobile-nav-bar d-flex justify-content-between"
        [ngClass]="{
          'bg-primary': isKid
        }"
      >
        <a class="nav-item fw-bold brand p-1" [routerLink]="['/']" routerLinkActive="router-link-active">
          <label id="homeLink" class="accessibility-only">Go To Home Page</label>
          <img alt="" class="home-logo" src="assets/images/logo.png" draggable="false" />
        </a>

        <!--Close-->
        <div class="nav-item">
          <button
            [ngClass]="{
              'kids-close-btn rounded': isKid
            }"
            attr.aria-label="{{ 'nav.toggle.screenreader' | translate }}"
            class="nav-item fw-bold navbar-toggler m-0 px-2"
            (click)="isCollapsed = !isCollapsed"
          >
            <span
              class="icon material-icons text-white material-mobile-nav text-black"
              [ngClass]="{
                'text-black': isKid
              }"
              >close</span
            >
          </button>
        </div>
      </div>

      <fgb-barcode [isMenu]="true"></fgb-barcode>

      <!-- Nav Buttons -->
      <div class="mobile-nav-button-container">
        <a
          [ngClass]="{
            'text-white': isKid
          }"
          class="nav-item fw-bold large-item"
          [routerLink]="['/']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.home' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>

        <a
          [ngClass]="{
            'text-white': isKid
          }"
          class="nav-item"
          [routerLink]="['/rewards']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.rewards' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>

        <a
          [ngClass]="{
            'text-white': isKid
          }"
          class="nav-item"
          [routerLink]="['/challenges']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.challenges' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>

        <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.offers'">
          <ng-container *inPopulation="populations.Default">
            <a
              class="nav-item"
              [routerLink]="['/offers']"
              [routerLinkActive]="'active'"
              [routerLinkActiveOptions]="{ exact: true }"
            >
              <div class="nav-item-title-div">
                <div class="nav-text fw-bold">{{ 'nav.offers' | translate }}</div>
              </div>
              <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
            </a>
          </ng-container>
        </ng-container>

        <ng-container *inPopulation="populations.Kids">
          <a
            class="nav-item text-white"
            [routerLink]="['/training-zone']"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <div class="nav-item-title-div">
              <div class="nav-text fw-bold">{{ 'nav.training.zone' | translate }}</div>
            </div>
            <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
          </a>
        </ng-container>

        <a
          [ngClass]="{
            'text-white': isKid
          }"
          class="nav-item"
          [routerLink]="['/tv']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.gallery' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>

        <a
          [ngClass]="{
            'text-white': isKid
          }"
          class="nav-item"
          [routerLink]="['/games']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.games' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>

        <ng-container *inPopulation="populations.Default">
          <a class="nav-item" href="{{ 'nav.benefits.url' | translate }}">
            <div class="nav-item-title-div">
              <div class="nav-text fw-bold">{{ 'nav.benefits' | translate }}</div>
            </div>
            <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
          </a>
        </ng-container>

        <a
          [ngClass]="{
            'text-white': isKid
          }"
          class="nav-item"
          target="_blank"
          [routerLink]="['/faq']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.faq' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>

        <a
          [ngClass]="{
            'text-white': isKid
          }"
          class="nav-item"
          href="{{ 'nav.contact.us.url' | translate }}"
          target="_blank"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.contact.us' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>

        <a
          [ngClass]="{
            'text-white': isKid
          }"
          class="nav-item"
          [routerLink]="['/terms']"
          target="_blank"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <div class="nav-item-title-div">
            <div class="nav-text fw-bold">{{ 'nav.terms' | translate }}</div>
          </div>
          <div><span class="icon material-icons mx-0" aria-hidden="true">chevron_right</span></div>
        </a>

        <a
          [ngClass]="{
            'text-white': isKid
          }"
          class="nav-item s logout-link-div"
          (click)="logout()"
        >
          <div class="nav-text fw-bold">{{ 'nav.log.out' | translate }}</div>
        </a>
      </div>
    </div>
  </div>
</div>
